import { usePutItem } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import apiConfig from 'Application/configurations/apiConfig';
import IListCompanyUnit from "../ListCompanyUnits/IListCompanyUnit";
import { useAccessTokens } from 'Features/Authentication';
import { useTranslation } from 'react-i18next';

function useUpdateCompanyUnits () {

    const { t } = useTranslation();
    const putItem = usePutItem();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;

    /** Create company units
     * @paramUpdate {IUpdateCompanyUnit} companyUnits - object which describes company units
     **/
    const updateCompanyUnits = async (id: string="", companyUnits: IListCompanyUnit[]) => {

        const basePath = apiConfig.basePath;
        const companyEndpoint = apiConfig.endpoints.companies;
        const unitEndpoint = apiConfig.endpoints.units;
        const url = new URL(`${basePath}/${companyEndpoint}/${id}/${unitEndpoint}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken,
            body: companyUnits
        }

        try {

            const response = await putItem(url, options);
         
            return responseHandler(response, "useUpdateCompanyUnits", { operation: "update", messageHeader: t("features.companyUnit.savedSuccessfully"), hide: false });

        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "General.RequestorNotExist") body = t('features.companyUnit.requestorNotExist');
            if (problemTitle === "Company.NotExist") body = t('features.company.notExist');
            if (problemTitle === "Company.CompanyDataAccessDenied") body = t('features.company.companyDataAccessDenied');
            if (problemTitle === "CompanyUnit.UpdatePermissionDenied") body = t('features.companyUnit.updatePermissionDenied');

            return errorHandler(error, "useUpdateCompanyUnits", { operation: "update", hide: false, messageBody: body });

        }

    }

    return { updateCompanyUnits }

}

export default useUpdateCompanyUnits;
